export default function getMaxMembers(community) {
  return {
    test: 10,
    "fll-brasil": 10,
    "ftc-brasil": 15,
    "frc-brasil": 1000,
    "f1-brasil": 6,
    desafiocovid: 10,
    desafiorelampago: 10,
    "fll-open-brazil": 10,
    "off-season-sesi-mt": 10,
  }[community];
}



// WEBPACK FOOTER //
// ./src/helpers/events/getMaxMembers.js